import Image1 from "../../assets/samarthkapila.jpg";
import Image2 from "../../assets/mahimaarora.png";
import Image3 from "../../assets/testimonial3.png";

export const Data = [
    {
        id: 1,
        image: Image1,
        title: "Samarth Kapila",
        description: "A really dedicated young coding enthusiast and delivers exceptional results always.",
        link: "https://www.linkedin.com/in/samarth-kapila-b78b42101/?originalSubdomain=in"
    },
    {
        id: 2,
        image: Image2,
        title: "Mahima Arora",
        description: "Chaitany is extremely meticulous with every task assigned. He also clears all his doubts at once so as to deliver up to the mark projects",
        link: "https://www.linkedin.com/in/mahima-arora-987646140/"

    },
    {
        id: 3,
        image: Image3,
        title: "Sara Cill",
        description: "A really good job, all aspects of the project were followed step by step and with good results.",
        link: "https://www.linkedin.com/in/samarth-kapila-b78b42101/?originalSubdomain=in"

    },
]